// Relative path: src/components/ReviewCard.js
import React from 'react';
import PropTypes from 'prop-types';

const ReviewCard = ({
  title,
  author,
  sourceUrl,
  imageSrc,
  logoSrc,
  link,
  authorImg,
  imageClassName,
}) => {
  return (
    <div className="bg-white hover:bg-gray-100 rounded-lg w-full shadow-inherit shadow-black border-gray-300 border flex flex-col justify-between transition min-h-[100px]">
      <div className="p-3">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            {authorImg ? (
              <img
                src={authorImg}
                alt="Author"
                className="w-10 h-10 object-contain rounded-full"
              />
            ) : (
              // Bubble with first letter of reviewerName if no authorImg
              <div className="w-10 h-10 rounded-full bg-gray-300 flex items-center justify-center">
                <span className="text-gray-600">
                  {author.charAt(0)}
                </span>
              </div>
            )}
            <div>
              <span className="font-semibold text-gray-800">{author}</span>
            </div>
          </div>
          {logoSrc && (
            <img
              src={logoSrc}
              alt="Brand Logo"
              className="w-14 h-10 object-contain"
            />
          )}
        </div>
      </div>

      <div className="p-3">
        <a
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          className="text-black hover:underline text-s line-clamp-2"
        >
          {title}
        </a>
      </div>

      {imageSrc && (
        <div
          className="relative w-full bg-gray-200 overflow-hidden"
          style={{ paddingTop: '90%' }} // Controls forced aspect ratio
        >
          <img
            src={imageSrc}
            alt="Review Content"
            className={`absolute top-0 left-0 w-full h-full object-contain ${imageClassName || ''}`}
          />
        </div>
      )}

      <div className="p-4">
        <a
          href={sourceUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="font-medium hover:underline text-mm_blue bg-white border border-gray-300 inline-flex items-center justify-center w-full px-6 py-0.5 text-sm rounded-full transition duration-300 mt-8"
        >
          See Review
        </a>
      </div>
    </div>
  );
};

ReviewCard.propTypes = {
  title: PropTypes.node.isRequired,
  author: PropTypes.string.isRequired,
  sourceUrl: PropTypes.string.isRequired,
  imageSrc: PropTypes.string,
  logoSrc: PropTypes.string,
  link: PropTypes.string.isRequired,
  authorImg: PropTypes.string,
  imageClassName: PropTypes.string,
};

export default ReviewCard;
